import { IBieuDoResponse } from "../../../model/respone/bieu-do/IBieuDoResponse";
import { IBieuDoActionTypes } from "../../action-types/bieu-do/IBieuDoActionTypes";
import { IBieuDoReducer } from "../../reducer-model/bieu-do/IBieuDoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IBieuDoReducer = {
  bieuDos: [] as IBieuDoResponse[],
};
export const bieuDoReducer = (
  state: IBieuDoReducer = iniState,
  action: IBieuDoActionTypes
): IBieuDoReducer => {
  switch (action.type) {
    case "BIEU_DO_LOAD_START":
      var exist = state.bieuDos.find((p) => p.type === action.payload.type);
      if (!exist) {
        return {
          ...state,
          bieuDos: [
            ...state.bieuDos,
            {
              type: action.payload.type,
              status: eReducerStatusBase.is_loading,
              data: [],
            } as IBieuDoResponse,
          ],
        };
      }
      return {
        ...state,
        bieuDos: [
          ...state.bieuDos.filter((g) => g.type !== action.payload.type),
          {
            ...exist,
            status: eReducerStatusBase.is_loading,
            data: {},
          } as IBieuDoResponse,
        ],
      };
    case "BIEU_DO_LOAD_SUCCESS":
      const exists = state.bieuDos.some((t) => t.type === action.payload.type);

      return {
        ...state,
        bieuDos: exists
          ? state.bieuDos.map((t) =>
              t.type === action.payload.type ? { ...t, ...action.payload } : t
            )
          : [...state.bieuDos, action.payload],
      };
    case "BIEU_DO_RELOAD_ALL":
      return {
        ...state,
        bieuDos: state.bieuDos.map((g) => {
          return {
            ...g,
            status: eReducerStatusBase.is_need_reload,
          };
        }),
      };
    default:
      return state;
  }
};
